import { api } from './client'
import type { BlogPostDetail, BlogPostListResponse } from '../types/blog'

export const blogApi = {
  listPosts: () => api.get<BlogPostListResponse>('/blog/posts'),
  getPost: (slug: string) => api.get<BlogPostDetail>(`/blog/posts/${slug}`),
}
